interface LikeAttachment {
  id: number
}

interface LikeSnippet {
  id: number,
  insights: Array<LikeAttachment>,
  story: null | (LikeAttachment & {
    relatedAssets?: null | Array<number>
  }),
  deleteToReplacePrevAttachmentId?: number
}

export const getUpdatedSnippetsForAnalytics = <S extends LikeSnippet>(
  snippets: Array<S>,
  attachments: Array<LikeAttachment>,
  snippetId: number
): Array<S> => (
    snippets.map(snippet => {
      const updatedSnippet = {
        ...snippet
      };

      if (updatedSnippet.id === snippetId) {
        updatedSnippet.insights = [
          ...updatedSnippet.insights,
          ...attachments
        ];

        if (updatedSnippet.story) {
          updatedSnippet.story = {
            ...updatedSnippet.story,
            relatedAssets: updatedSnippet.insights.map(ins => ins.id)
          };
        }
      }

      return updatedSnippet;
    })
  );

export const getUpdatedSnippetsForHighres = <S extends LikeSnippet>(
  snippets: Array<S>,
  attachments: Array<LikeAttachment>,
  snippetId: number
): Array<S> => (
    snippets.map(snippet => {
      const updatedSnippet = {
        ...snippet
      };

      if (updatedSnippet.id === snippetId) {
        updatedSnippet.story = {
          ...attachments[0],
          relatedAssets: updatedSnippet.insights.map(ins => ins.id),
          id: updatedSnippet.deleteToReplacePrevAttachmentId ?? attachments[0].id
        };

        updatedSnippet.deleteToReplacePrevAttachmentId = attachments[0].id;
      }

      return updatedSnippet;
    })
  );

export const getSnippetsAfterAttachmentDeletion = <S extends LikeSnippet>(
  snippets: Array<S>,
  snippetId: number,
  attachmentId: number
) => (
    snippets.map(snippet => {
      const updatedSnippet = {
        ...snippet
      };

      if (updatedSnippet.id !== snippetId) {
        return updatedSnippet;
      }

      if (updatedSnippet.story?.id === attachmentId) {
        updatedSnippet.deleteToReplacePrevAttachmentId = updatedSnippet.story.id;
        updatedSnippet.story = null;
      } else if (updatedSnippet.insights.map(ins => ins.id).includes(attachmentId)) {
        updatedSnippet.insights = updatedSnippet.insights.filter(ins => ins.id !== attachmentId);

        if (updatedSnippet.story) {
          updatedSnippet.story = {
            ...updatedSnippet.story,
            relatedAssets: updatedSnippet.insights.map(ins => ins.id)
          };
        }
      }

      return updatedSnippet;
    })
  );

export const getSnippetsAfterAttachmentReplacement = <
  S extends LikeSnippet,
  A extends LikeAttachment
>(
    snippets: Array<S>,
    newAttachment: A,
    snippetId: number,
    oldAttachmentId: number
  ): Array<S> => (
    snippets.map(snippet => {
      const updatedSnippet = {
        ...snippet
      };


      if (updatedSnippet.id !== snippetId) {
        return updatedSnippet;
      }

      if (updatedSnippet.story?.id === oldAttachmentId) {
        updatedSnippet.story = {
          ...newAttachment,
          id: oldAttachmentId,
          relatedAssets: updatedSnippet.insights.map(ins => ins.id)
        };
      } else if (updatedSnippet.insights.map(ins => ins.id).includes(oldAttachmentId)) {
        updatedSnippet.insights = updatedSnippet.insights.map(ins => {
          if (ins.id !== oldAttachmentId) {
            return ins;
          }

          return newAttachment;
        });

        if (updatedSnippet.story) {
          updatedSnippet.story = {
            ...updatedSnippet.story,
            relatedAssets: updatedSnippet.insights.map(ins => ins.id)
          };
        }
      }

      return updatedSnippet;
    })
  );
